var map = {
	"./music-instructions.json": 4657,
	"./music-library-intro2024.json": 4658,
	"./music-library-launch2024.json": 4659,
	"./music-progression.json": 4660,
	"./startSourcesAdvanced.json": 4661,
	"./startSourcesSimple.json": 4662,
	"./startSourcesSimple2.json": 4663,
	"./startSourcesTracks.json": 4664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4436;